import { api } from '../config/api'
import {
  generateApiUrl,
  generateApiUrlWithGetParams,
  generateGetApiUrl,
} from '../utils/urlHelpers'
import { Methods, makeRequest } from './Request'

export const impersonateUser = (user_id) => {
  let url = generateApiUrl(api.routes.users.impersonate, { id: user_id })
  url = `${url}?client_id=${process.env.KEYCLOAK_CLIENT_ID}`
  return makeRequest(url, Methods.GET)
}

export const getAccount = (companyId) => {
  let url = generateApiUrl(api.routes.account.get)

  if (companyId) {
    url = generateApiUrlWithGetParams(api.routes.account.get, null, false, {
      company_id: companyId,
    })
  }

  return makeRequest(url, Methods.GET)
}

export const updateAccount = (values) => {
  const url = generateApiUrl(api.routes.account.get)

  return makeRequest(url, Methods.POST, values)
}

export const checkEmail = (values) => {
  const url = generateApiUrl(api.routes.account.checkEmail)

  return makeRequest(url, Methods.POST, values, { Authorization: null })
}

export const registerUser = (values) => {
  const url = generateApiUrl(api.routes.account.registerUser)

  return makeRequest(url, Methods.POST, values, { Authorization: null })
}

export const registerCompany = (values) => {
  const url = generateApiUrl(api.routes.account.registerCompany)

  return makeRequest(url, Methods.PATCH, values, { Authorization: null })
}

export const getUsers = (params) => {
  const url = generateGetApiUrl(api.routes.users.list, params)

  return makeRequest(url, Methods.GET)
}

export const getUser = (id) => {
  const url = generateApiUrl(api.routes.users.get, { id })

  return makeRequest(url, Methods.GET)
}

export const updateUserRole = (userId, companyId, params) => {
  const url = generateApiUrl(api.routes.users.role, { companyId, userId })

  return makeRequest(url, Methods.POST, params)
}

export const deleteUser = (companyId, invitationId) => {
  const url = generateApiUrl(api.routes.users.delete, {
    companyId,
    invitationId,
  })

  return makeRequest(url, Methods.POST)
}
